export const AUTH_COLORS = {
  accent: '#e8624a',
  accentHover: '#d2553e',
  pageBg: '#f0ece8',
  illustrationBg: '#F0F7FF',
  heroFrom: '#1a2d45',
  heroVia: '#0f1e30',
  heroTo: '#091624',
  inputLabel: '#555',
  mutedText: '#999',
  softText: '#888',
  footerText: '#bbb',
  cardBg: '#fdf9f7',
  white: '#fff',
  softBorder: 'rgba(0,0,0,0.08)',
  inputBorder: 'rgba(0,0,0,0.12)',
  secondaryText: '#555',
  error: '#c94d35',
} as const

export const AUTH_CLASSES = {
  fontScope: 'auth-login-scope',
  serifText: 'auth-login-serif',
  loginPageBg: 'bg-[#f0ece8]',
  loginHeroGradient: 'bg-gradient-to-br from-[#1a2d45] via-[#0f1e30] to-[#091624]',
  accentText: 'text-[#e8624a]',
  accentLink: 'text-[#e8624a] no-underline hover:underline',
  accentDot: 'bg-[#e8624a]',
  mutedText: 'text-[#999]',
  mutedUnderlineLink: 'text-[#999] underline',
  accentPill: 'border border-[#e8624a]/45 bg-[#e8624a]/20',
  accentBadge: 'border border-[#e8624a]/50 bg-[#e8624a]/25 text-[#e8624a]',
  inputFocus: 'focus:!border-[#e8624a] focus:!outline-none focus:!ring-0 focus:!shadow-none',
  passwordFocus: 'focus-within:!border-[#e8624a] focus-within:!outline-none focus-within:!ring-0',
  primaryButtonState: 'hover:!bg-[#d2553e] disabled:!bg-[#e8624a]/40 disabled:!text-white',
  secondaryButtonState:
    'hover:!border-[#e8624a] hover:!bg-[#e8624a]/[0.06] hover:!text-[#e8624a] disabled:!text-[#bbb]',
  patientCard: 'border border-[rgba(0,0,0,0.08)] bg-[#fdf9f7]',
  secondaryText: 'text-[#555]',
  softTextClass: '!text-[#888]',
  errorText: 'text-[#c94d35]',
  fieldLabel: 'text-[12px] font-semibold tracking-[0.04em] text-[#555]',
} as const

export const AUTH_LOGIN_FIELD_LABEL_STYLES = {
  fontSize: 12,
  fontWeight: 600,
  color: AUTH_COLORS.inputLabel,
  letterSpacing: '0.04em',
  marginBottom: 7,
} as const

const authFieldInputStyles = {
  height: 48,
  borderRadius: 12,
  borderWidth: 1.5,
  borderColor: AUTH_COLORS.inputBorder,
  padding: '0 16px',
  fontSize: 15,
} as const

export const AUTH_LOGIN_TEXT_INPUT_STYLES = {
  label: AUTH_LOGIN_FIELD_LABEL_STYLES,
  input: authFieldInputStyles,
} as const

export const AUTH_LOGIN_PASSWORD_INPUT_STYLES = {
  label: AUTH_LOGIN_FIELD_LABEL_STYLES,
  input: {
    ...authFieldInputStyles,
    paddingLeft: 16,
  },
  innerInput: {
    height: 48,
  },
} as const

export const AUTH_LOGIN_CHECKBOX_STYLES = {
  label: {
    fontSize: 12,
    fontWeight: 500,
    color: AUTH_COLORS.inputLabel,
    letterSpacing: '0.02em',
    paddingLeft: 8,
    cursor: 'pointer',
  },
  input: {
    '--checkbox-color': AUTH_COLORS.accent,
    cursor: 'pointer',
  },
} as const

export const AUTH_LOGIN_PRIMARY_BUTTON_STYLES = {
  root: {
    marginTop: 8,
    height: 48,
    borderRadius: 999,
    backgroundColor: AUTH_COLORS.accent,
    color: AUTH_COLORS.white,
    fontWeight: 600,
    fontSize: 15,
    transition: 'opacity 0.2s, background-color 0.2s',
  },
} as const

export const AUTH_LOGIN_SECONDARY_BUTTON_STYLES = {
  root: {
    marginTop: 8,
    height: 48,
    borderRadius: 999,
    backgroundColor: AUTH_COLORS.white,
    color: AUTH_COLORS.secondaryText,
    border: `1.5px solid ${AUTH_COLORS.inputBorder}`,
    fontWeight: 600,
    fontSize: 15,
    transition: 'background-color 0.2s, border-color 0.2s, color 0.2s',
  },
} as const
